'use client';

import { useEffect, useMemo, useState } from 'react';

export const useDisplayModeStandalone = () => {
  const [standalone, setStandalone] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(display-mode: standalone)');
    type NavigatorWithStandalone = Navigator & { standalone?: boolean };
    const update = () => {
      const nav = window.navigator as NavigatorWithStandalone;
      setStandalone(mq.matches || nav.standalone === true);
    };
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);
  return standalone;
};

export const useIsIOS = () => {
  return useMemo(() => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent;
    const isiOSUA = /iPad|iPhone|iPod/.test(ua);
    const isIPadOS13Plus =
      /Mac/.test(ua) && // Yes, iPad user agent includes "Mac" in iPadOS 13+
      'maxTouchPoints' in navigator &&
      navigator.maxTouchPoints > 1;
    return isiOSUA || isIPadOS13Plus;
  }, []);
};
